import { render, staticRenderFns } from "./AppStoreChannelDetail.vue?vue&type=template&id=3ef5434b&scoped=true"
import script from "./AppStoreChannelDetail.vue?vue&type=script&lang=js"
export * from "./AppStoreChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./AppStoreChannelDetail.vue?vue&type=style&index=0&id=3ef5434b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5434b",
  null
  
)

export default component.exports